import { HomeContainer } from "@/features/app/containers/home-container";
import { beforePlatformAdminGuard } from "@/features/auth/guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin")({
  beforeLoad: beforePlatformAdminGuard,
  component: HomeContainer,
});
